// extracted by mini-css-extract-plugin
module.exports = {"oibCol":"InstitutionBasicInfo_oibCol__3A-N9"};